import NonCompeteEditContainer from './non-compete-edit-container';

export default NonCompeteEditContainer;
